import { render, staticRenderFns } from "./ModalImpressao.vue?vue&type=template&id=98700046&scoped=true"
import script from "./ModalImpressao.vue?vue&type=script&lang=js"
export * from "./ModalImpressao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98700046",
  null
  
)

export default component.exports